import React, { useState, useEffect } from 'react';
import {
  IonCardContent,
  IonIcon,
  IonRow,
  IonCol,
  IonBadge,
  IonButton
} from '@ionic/react';
import {
  PLEASE_CHECK_NETWORK_CONNECTIVITY_MESSAGE,
  NO_NETWORK
} from '../../../utils/constants';
import './RecentCard.scss';
import { getDateRange, getDestinationStateValue, formatStatesList } from '../../../web/containers/SearchContainer/searchUtility';

interface recentProps {
  recentData: any;
  updateFavorite: (fav: boolean, data: any) => void;
  favoriteFlag: boolean;
  isNetworkAvailable: boolean;
  showAlert: (data: any) => void;
  onResultClick: any;
  disableBtn: boolean;
  updateFlag: boolean;
  searchedDataParams?: any;
}
export const RecentCard: React.FC<recentProps> = ({
  recentData,
  updateFavorite,
  isNetworkAvailable,
  showAlert,
  onResultClick,
  disableBtn = false,
  updateFlag = false,
  searchedDataParams
}) => {
  const [fav, setFav] = useState<boolean>(false);
  useEffect(() => {
    if (updateFlag) {
      setFav(false);
    }
  }, [updateFlag]);
  useEffect(() => {
    setFav(recentData.favouritesearchindicator);
  }, [recentData]);
  let states = getDestinationStateValue(recentData);
  return (
    <IonCardContent className="card-content saved-card-content">

      <IonRow className="saved-card-row">
        <IonCol size="3">
          <p className="trailer-heading">{recentData.trailertype}</p>
        </IonCol>
        <IonCol size="6" className="details-section">
          <div className="stops-border"></div>
          <IonRow>
            <IonCol>
              <div className="state-details">
                <IonIcon src="assets/icon/origin_icon.svg" />
                <span>
                  {recentData.originCity || 'Anywhere'}{recentData.originState && recentData.originState !== "Anywhere" ? ', ' + recentData.originState : ''}
                </span>
              </div>
              {recentData.originCity === null || recentData.originCity === 'Anywhere' ? (
                ''
              ) : (
                  <IonBadge className="originRadius">{recentData.originradius} miles</IonBadge>
                )}
              {recentData.originCity === null || recentData.originCity === 'Anywhere' ? (
                ''
              ) : (
                  <IonBadge className="pickupDate">
                    {getDateRange(searchedDataParams.pickupStartDate, searchedDataParams.pickupEndDate)}
                  </IonBadge>
                )}
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <div className="state-details">
                <IonIcon src="assets/icon/destination_icon.svg" />
                <span>
                  {(recentData.destinationCity === 'Anywhere' || (recentData.destinationCity === null && states.length === 0)) ? (
                    'Anywhere'
                  ) : (
                      <>
                        {recentData.destinationCity && recentData.destinationCity !== 'Anywhere' ?
                          `${recentData.destinationCity}${states && states.length === 1 ? ', ' + states[0] : ''}`
                          :
                          `${states && formatStatesList(states).join(', ')}`
                        }
                      </>
                    )}
                </span>
              </div>
              {recentData.destinationCity === null || recentData.destinationCity === 'Anywhere' ? (
                ''
              ) : (
                  <IonBadge className="originRadius">{recentData.destinationradius} miles</IonBadge>
                )}
              {recentData.destinationCity === null || recentData.destinationCity === 'Anywhere' ? (
                ''
              ) : (
                  <IonBadge className="pickupDate">
                    {getDateRange(searchedDataParams.dropStartDate, searchedDataParams.dropEndDate)}
                  </IonBadge>
                )}
            </IonCol>
          </IonRow>
        </IonCol>
        <IonCol size="3" className="details-section text-center">
          <div>
            <span
              className="fav-link"
              data-testid="favLink"
              onClick={e => {
                e.stopPropagation();
                fav ? updateFavorite(false, recentData) : updateFavorite(true, recentData);
                if (!isNetworkAvailable) {
                  showAlert({
                    isShowAlert: true,
                    alertMessage: PLEASE_CHECK_NETWORK_CONNECTIVITY_MESSAGE,
                    alertTitle: NO_NETWORK
                  });
                  return;
                }
                fav ? setFav(false) : setFav(true);
              }}>
              <IonIcon
                src={`assets/icon/${fav ? 'fav-icon-desktop' : 'unfav-icon-desktop'}.svg`}
                className={fav?"fav-star":"eye-icon"}
              /> <span className="fav-text">{fav ? 'Unfavorite' : 'Favorite'}</span>
            </span>
          </div>
          {!disableBtn && (
            <div data-testid="see-results">
              <IonButton className="secondary-cta-btn-web" onClick={onResultClick}>
                See Results
              </IonButton>
            </div>
          )}
        </IonCol>
      </IonRow>

    </IonCardContent>
  );
};
